// @ts-nocheck
import styled from "styled-components";
import { useNavigate, useLocation } from "react-router-dom";
import { useState } from "react";
import { useSelector } from "react-redux";
import listCategory from "../home_components/ListCategoryJson";
import { Link } from "react-router-dom";
import ToggleMenuIcon from "../ui_components/ToggleMenuIcon";
import BackArrowIcon from "../ui_components/BackArrowIcon";
import colors from "../../styles/colors";
import { LoadingState } from "../stats_components/LoadingState";

const Container = styled.div `
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 50px;
    background-color: black;
    display: flex;
    justify-content: space-between;
    align-items: start;

    & .footer-info-text {
        margin: 0;
        padding: 0;
        font-size: 7px;
        font-weight: 500;
        padding-right: 20px;
        display: flex;
        align-items: center;
        justify-content: start;
        width: 45%;
        height: 100%;
        padding-left: 10px;

        & .footer-info-linkedin-icon {
            width: 5px;
            height: 5px;
            margin: 0 2px 0 5px;
        }
    }
`;

const BackButtonSection = styled.div `
    display: flex;
    justify-content: start;
    align-items: center;
    width: 33%;
    height: 100%;
    padding-left: 20px;

    & .back-arrow-icon {
        width: 30px;
        height: 30px;
        cursor: pointer;
    }
`;

const EmptySection = styled.div `
    width: 10%;
    height: 100%;
`;

const MobileMenuSection = styled.div `
    position: relative;
    display: flex;
    justify-content: end;
    align-items: center;
    width: 33%;
    height: 100%;
    padding-right: 20px;

    & .section_name {
        color: white;
        padding: 0;
        margin: 0;
    }

    & img.toggle-menu-icon {
        width: 30px;
        height: 30px;
        cursor: pointer;
    }
`
const VisibileMobileMenuSection = styled.div `
    position: absolute;
    bottom: 50px;
    left: 0px;
    padding: 5px;
    background-color: ${colors.bgColorBlack2};
    color: white;
    z-index: 9999;
`

const OverlayMobile = styled.div `
    position: relative;
    display: flex;
    flex-direction: column-reverse;
    justify-content: end;
    align-items: center;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 2px solid ${colors.bgColorBlack2};
    padding: 2px;

    & .section-mobile-name {
        color: white;
        font-size: 13px;
        text-align: center;
        margin: 0;
        padding: 0;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        width: 100%;
        font-family: CameronSansMedium, CameronSansLight, Trebuchet MS, Arial, Helvetica, Verdana, Tahoma, sans-serif;
        font-weight: 500;
    }

`

const BoxSectionMobileName = styled.div `
    display: flex;
    justify-content: start;
    align-items: center;
    width: 100%;
    height: 100%;
    padding: 10px 30px;
    background-color: ${colors.bgColorBordeaux};
    border-bottom: 1px solid gray;

    & .link_css_mobile {
        text-decoration: none;
        color: white;
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
    }
`


function MobileFooter() {
    const {isAuthenticated, user} = useSelector((state) => state.auth);
    const [visibilityMobileMenu, setVisibilityMobileMenu] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const [isLoading, setIsLoading] = useState(false);

    function handleVisibilityMobileMenu() {
        setVisibilityMobileMenu(!visibilityMobileMenu);
    }

    function handleGoBack() {
        setIsLoading(true);
        navigate(-1); // Torna alla pagina precedente nella cronologia
        setIsLoading(false);
    }

    // Controlla se siamo sulla homepage
    const isHomepage = location.pathname === '/';

    // isLoading
    if(isLoading) {
        return <LoadingState />;
    }

    return (
        <Container className='mobile-footer'>
            {/* Sezione sinistra - Pulsante Torna indietro o spazio vuoto */}
            {!isHomepage ? (
                <BackButtonSection>
                    <BackArrowIcon 
                        className="back-arrow-icon" 
                        onClick={handleGoBack}
                        size={28}
                        color="white"
                    />
                </BackButtonSection>
            ) : (
                <p className='footer-info-text'>
                    Credits: 
                    <img src= {process.env.REACT_APP_STORAGE_URL + "img/utilities/LogoLinkedin.png"} alt="Linkedin Icon" className='footer-info-linkedin-icon' />
                    <a href="https://www.linkedin.com/in/simone-pancione-733152231/" target="_blank" rel="noopener noreferrer">Simone Pancione</a>
                </p>
            )}

            {/* Sezione centrale - Spazio vuoto */}
            <EmptySection />

            {/* Sezione destra - Toggle Menu (sempre a destra) */}
            <MobileMenuSection
                onClick={() => setVisibilityMobileMenu(!visibilityMobileMenu)}
                className="MobileMenuSection"
            >
                {/* // SVG toggle menu  */}
                <ToggleMenuIcon 
                    className="toggle-menu-icon" 
                    onClick={() => handleVisibilityMobileMenu()}
                    size={28}
                    color="white"
                />

                {/* Menu che si vede al cliccare il pulsante */}
                {visibilityMobileMenu && (
                    <VisibileMobileMenuSection className="VisibileMobileMenuSection">
                        <OverlayMobile className="overlay-mobile">
                            {listCategory.map((category, index) => (
                                category.isInHeader ? (
                                    <BoxSectionMobileName className="box-section-mobile-name">
                                        <Link className="link_css_mobile" key={category.title + '-' + index} to={category.link}>
                                            <p className="section-mobile-name">{category.title}</p>
                                        </Link>
                                    </BoxSectionMobileName>
                                ) : null
                            ))}
                        </OverlayMobile>
                    </VisibileMobileMenuSection>
                )}

            </MobileMenuSection>
        </Container>
    )
}

export default MobileFooter;
